// Roadmap / offene Punkte & Ideen – wird auf der Seite „Roadmap" angezeigt.
// Pflege: einfach Einträge ergänzen/ändern. status: 'offen' (geplant/besprochen),
// 'idee' (Vorschlag), 'in_arbeit'. prio: 'hoch' | 'mittel' | 'niedrig'. aufwand: 'S' | 'M' | 'L'.

export type RoadmapStatus = 'offen' | 'idee' | 'in_arbeit';
export type RoadmapPrio = 'hoch' | 'mittel' | 'niedrig';
export type RoadmapAufwand = 'S' | 'M' | 'L';

export interface RoadmapItem {
  title: string;
  description?: string;
  status: RoadmapStatus;
  prio: RoadmapPrio;
  aufwand: RoadmapAufwand;
}

export interface RoadmapCategory {
  id: string;
  label: string;
  items: RoadmapItem[];
}

export const ROADMAP_STAND = '23.08.2026';

export const roadmap: RoadmapCategory[] = [
  {
    id: 'infra',
    label: 'Infrastruktur & Sicherheit',
    items: [
      { title: 'Offsite-Backup (Hetzner Storage-Box)', status: 'offen', prio: 'hoch', aufwand: 'M',
        description: 'Verschlüsselte, tägliche Sicherung außerhalb des Servers (restic/SFTP, pro Kunde pg_dump mit Aufbewahrung). Wichtigste offene Absicherung.' },
      { title: 'Grünapp-DB-Passwort rotieren', status: 'offen', prio: 'mittel', aufwand: 'S',
        description: 'Vorsichtsmaßnahme, da der Postgres-Port des alten Servers eine Zeit lang offen war.' },
      { title: 'Backend-Cleanup (index.ts)', status: 'offen', prio: 'niedrig', aufwand: 'S',
        description: 'Alte CORS-Liste aufräumen, hartcodierte Health-Check-Version ersetzen.' },
      { title: 'Backup-Monitoring', status: 'idee', prio: 'niedrig', aufwand: 'S',
        description: 'Kurze Meldung/Log, ob das tägliche Backup gelaufen ist.' },
    ],
  },
  {
    id: 'reporting',
    label: 'Auswertung & Reporting',
    items: [
      { title: 'Verkehrssicherheits-Nachweis als PDF', status: 'idee', prio: 'hoch', aufwand: 'M',
        description: 'Bericht „Kontroll- und Sicherungspflicht erfüllt": überfällige Kontrollen, nicht verkehrssichere Bäume, Reaktionszeiten. Großer Mehrwert für Kommunen.' },
      { title: 'Verkehrssicherheits- & Kontroll-Auswertung', status: 'in_arbeit', prio: 'hoch', aufwand: 'M',
        description: 'Eigener Block in der Auswertung: Verteilung Verkehrssicherheit (Ampel), kontrolliert vs. überfällig, Kontrollen im Zeitverlauf, nicht verkehrssicher pro Ort. Größter fachlicher Mehrwert.' },
      { title: 'Baumbestand-Auswertung', status: 'idee', prio: 'mittel', aufwand: 'M',
        description: 'Bestand nach Baumart, Zustand und Ort – ergänzt die Maßnahmen-/Kostensicht um „was haben wir".' },
      { title: 'Fällungen-Auswertung im Zeitraum', status: 'idee', prio: 'niedrig', aufwand: 'S',
        description: 'Gefällte Bäume (GF-) je Zeitraum als Kennzahl/Verlauf.' },
      { title: 'Geplante vs. erledigte Kosten (Budget)', status: 'idee', prio: 'niedrig', aufwand: 'M',
        description: 'Budget-Tracking: was ist geplant/beauftragt vs. erledigt.' },
      { title: 'Auswertung „Bauhof-Stunden"', status: 'offen', prio: 'mittel', aufwand: 'M',
        description: 'Interne Stunden/Kosten aus den Bauhof-LVs zusammengezählt (intern vs. extern beauftragt).' },
      { title: 'Verkehrssicherheit-Verteilung im Dashboard', status: 'idee', prio: 'mittel', aufwand: 'S',
        description: 'Ampel-Verteilung (gegeben/zweifelhaft/nicht gegeben) als Kachel oder Balken.' },
      { title: 'Kataster-Export nach Excel/CSV', status: 'idee', prio: 'mittel', aufwand: 'S',
        description: 'Gefilterte Baumliste als Datei für Haushaltsplanung/Weitergabe.' },
      { title: 'Jahresbericht', status: 'idee', prio: 'niedrig', aufwand: 'M',
        description: 'Baumbestand + Maßnahmen/Kontrollen eines Jahres als PDF/Excel.' },
    ],
  },
  {
    id: 'kataster',
    label: 'Baumkataster',
    items: [
      { title: 'Alle Treffer über alle Seiten auswählen', status: 'offen', prio: 'mittel', aufwand: 'M',
        description: 'Backend-Endpoint für alle IDs zum aktuellen Filter; ergänzt die seitenübergreifende Auswahl.' },
      { title: 'Sammel-Bearbeiten von Feldern', status: 'idee', prio: 'mittel', aufwand: 'M',
        description: 'Für mehrere ausgewählte Bäume ein Feld gemeinsam setzen (Eigentümer, Ort, Kontrollintervall).' },
      { title: 'Baum-Historie / Zeitleiste', status: 'idee', prio: 'mittel', aufwand: 'M',
        description: 'Chronik pro Baum: Kontrollen, Maßnahmen, Zustandsänderungen.' },
      { title: 'Datenqualitäts-Report', status: 'idee', prio: 'niedrig', aufwand: 'S',
        description: 'Übersicht unvollständiger Datensätze (ohne Koordinaten/Baumart/Eigentümer).' },
      { title: 'QR-Code / Baumnummern-Schilder', status: 'idee', prio: 'niedrig', aufwand: 'M',
        description: 'QR am Baum öffnet den Datensatz – praktisch bei der Kontrolle vor Ort.' },
    ],
  },
  {
    id: 'karte',
    label: 'Karte',
    items: [
      { title: 'Koordinaten-Anzeige mobil ausblenden', status: 'offen', prio: 'niedrig', aufwand: 'S' },
      { title: 'Eigentümer-Farbpalette erweitern (>12)', status: 'offen', prio: 'niedrig', aufwand: 'S',
        description: 'Bei mehr als 12 Eigentümern wiederholen sich aktuell Farben.' },
      { title: 'Marker-Clustering bei kleinem Zoom', status: 'idee', prio: 'mittel', aufwand: 'M',
        description: 'Herausgezoomt Bäume gruppieren – übersichtlicher und schneller.' },
      { title: 'Kartenfilter nach Handlungsbedarf', status: 'idee', prio: 'mittel', aufwand: 'M',
        description: 'Auf der Karte z.B. nur nicht verkehrssichere Bäume oder offene Fällungen zeigen.' },
      { title: 'Distanz/Fläche messen', status: 'idee', prio: 'niedrig', aufwand: 'M' },
    ],
  },
  {
    id: 'lv',
    label: 'Leistungsverzeichnis',
    items: [
      { title: 'Standard-Leistungstexte final ausformulieren', status: 'offen', prio: 'mittel', aufwand: 'S',
        description: 'Die „xx m"-Platzhalter je Maßnahmentyp durch echte Formulierungen ersetzen.' },
      { title: 'LV duplizieren', status: 'idee', prio: 'niedrig', aufwand: 'S',
        description: 'Ein bestehendes LV als Vorlage kopieren.' },
      { title: 'LV-Status-Workflow', status: 'idee', prio: 'niedrig', aufwand: 'M',
        description: 'Stufen Entwurf → beauftragt → in Arbeit → abgeschlossen, mit Datum je Schritt.' },
    ],
  },
  {
    id: 'kontrollen',
    label: 'Kontrollen & mobiler Workflow',
    items: [
      { title: 'Erinnerungen für fällige/überfällige Kontrollen', status: 'idee', prio: 'hoch', aufwand: 'M',
        description: 'E-Mail-/In-App-Hinweis vor Fälligkeit – direkt haftungsrelevant.' },
      { title: 'Foto-Upload je Kontrolle/Maßnahme', status: 'idee', prio: 'mittel', aufwand: 'M',
        description: 'Belegfotos zur Dokumentation vor Ort.' },
      { title: 'Offline-fähige Kontrolle (PWA)', status: 'idee', prio: 'niedrig', aufwand: 'L',
        description: 'Erfassen ohne Empfang, später synchronisieren.' },
    ],
  },
  {
    id: 'nutzer',
    label: 'Nutzer & Rechte',
    items: [
      { title: 'Eigene Rolle „Bauhof"', status: 'idee', prio: 'niedrig', aufwand: 'M',
        description: 'Schlanke Rolle mit passenden Rechten statt Abbildung als erfasser.' },
      { title: 'Zwei-Faktor-Login (2FA)', status: 'idee', prio: 'niedrig', aufwand: 'M',
        description: 'Zusätzliche Absicherung, v.a. für Admins.' },
    ],
  },
  {
    id: 'kleinkram',
    label: 'Kleinkram / Beobachten',
    items: [
      { title: '„Gefahr im Verzug"-Filter prüfen', status: 'offen', prio: 'niedrig', aufwand: 'S',
        description: 'Sicherstellen, dass der Dashboard-Filter bei allen Kunden die exakte Zustands-Schreibweise trifft.' },
      { title: 'DB-Spalten-Kurznamen aufräumen', status: 'idee', prio: 'niedrig', aufwand: 'M',
        description: 'Abgeschnittene Spalten (eigentueme, lebenserw, vitalitaet …) sauber umbenennen. Kür.' },
    ],
  },
];
